//import liraries

import { NavLink, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { isPosAllowed } from "../../../utils/companyCapabilities";

// create a component
const StaffManagementSidebar = () => {
  const location = useLocation();
  const posAllowed = isPosAllowed(useSelector((state) => state.auth.profileData));
  return (
    <div
      className={`menu-item has-sub ${location.pathname.startsWith("/team") ? "active" : "" ||
          location.pathname.startsWith("/role") ? "active" : ""
        }`}
    >
      <div className="menu-link">
        <div className="menu-icon">
          <i className="fas fa-users"></i>
        </div>
        <div className="menu-text">Staff</div>
        <div className="menu-caret"></div>
      </div>
      <div className="menu-submenu">
        <div
          className={`menu-item ${
            (location.pathname === "/team/manageTeam" || 
             location.pathname.startsWith("/team/manageTeam") ||
             location.pathname.startsWith("/team/addTeamMember") ||
             location.pathname.startsWith("/team/updateTeamMember") ||
             location.pathname.startsWith("/team/teamSchedule")) ? "active" : ""
            }`}
        >
          <NavLink to="/team/manageTeam" className="menu-link">
            Staff List
          </NavLink>
        </div>
        {posAllowed && (
        <div
          className={`menu-item ${location.pathname.startsWith("/team/schedule") ? "active" : ""
            }`}
        >
          <NavLink to="/team/schedule" className="menu-link">
            Manage Schedule
          </NavLink>
        </div>
        )}
        {posAllowed && (
        <div
          className={`menu-item ${location.pathname.startsWith("/team/staffShiftReport") ? "active" : ""
            }`}
        >
          <NavLink to="/team/staffShiftReport" className="menu-link">
            Staff Shift Report
          </NavLink>
        </div>
        )}
        {posAllowed && (
        <div
          className={`menu-item ${location.pathname.startsWith("/team/staffWorkReport") ? "active" : ""
            }`}
        >
          <NavLink to="/team/staffWorkReport" className="menu-link">
            Staff Work Report
          </NavLink>
        </div>
        )}
        {posAllowed && (
        <div
          className={`menu-item ${location.pathname.startsWith("/team/payouts") ? "active" : ""
            }`}
        >
          <NavLink to="/team/payouts" className="menu-link">
            Payouts
          </NavLink>
        </div>
        )}
        {posAllowed && (
        <div
          className={`menu-item ${location.pathname.startsWith("/team/leave") ? "active" : ""
            }`}
        >
          <NavLink to="/team/leave" className="menu-link">
            Staff Leave
          </NavLink>
        </div>
        )}
        {posAllowed && (
        <div
          className={`menu-item ${location.pathname.startsWith("/role") ? "active" : ""
            }`}
        >
          <NavLink to="/role/manageStaffRole" className="menu-link">
            Role List
          </NavLink>
        </div>
        )}
      </div>
    </div>
  );
};

export default StaffManagementSidebar;
